module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "gold.0819ee23.png";